module.exports = __webpack_public_path__ + "static/media/nd-mx5-small-v2.75481a6c.jpg";